/* GraceYears — live preview dong COC ca nhan hoa.
   Toa do LAY THANG tu render_mug.py. Mot nguon su that duy nhat.

   BON BAI HOC BE NGUYEN — dung bo:
   1. Phai doi WEBFONT tai xong moi duoc ve. Ve som => do bang font du phong
      => chu bi thu nho hoac xuong dong khac han ban in.
   2. Neo theo TAM VET MUC (actualBoundingBox), KHONG neo baseline.
   3. Ban in dung DUNG font nay (Pinyon Script / Caveat / Cormorant Garamond),
      nen preview == ban in.
   4. 🔴 26/08 — DAI DOC DUOC CHI 0.325..0.675 cua dai in, khong phai 0.23..0.77.
      Coc la hinh tru: sat hai mep be mat quay nghieng gan het khoi nguoi nhin.
      Do tren mockup that: hang chu rong 1215 px bi CAT ca hai dau o CA 11oz lan 15oz.
      => moi dong chu phai <= 850 px. Qua thi XUONG DONG, khong phai thu nho.

   🔴 15 oz co khung in 2475x1275, KHONG phai 1155. Anh dat giua khung
      => thiet ke tut xuong 60 px. Preview phai ve dung nhu vay, neu khong
      thi loi hua "you see it before you buy" sai o dung nua so ban. */
(function () {
  var W = 2475, H = 1155, H15 = 1275, DY15 = (H15 - H) / 2;
  var L = 0.325, R = 0.675;
  var VW = Math.round((R - L) * W);
  var AN_TOAN = 850, TOI_DA_TEN = 8;

  var MAU  = ['#F08A5E', '#96B2D8', '#F3A8B2', '#F7CE7C', '#80B096', '#C4A4D0'];
  var NHUY = ['#78422C', '#465A78', '#964650', '#966E28', '#3C6450', '#604870'];

  var SPEC = {
    'garden-bouquet': { base: 'a', kieu: 'A' },
    'little-blooms':  { base: 'b', kieu: 'B' },
    'wildflower':     { base: 'b2', kieu: 'B2' }
  };

  /* Nhan dien mau: uu tien bien Liquid, nhung KHONG phu thuoc vao no. */
  function kind() {
    var k = (window.GY_MUG_KIND || '').trim();
    if (SPEC[k]) return k;
    var p = location.pathname || '';
    for (var key in SPEC) if (SPEC.hasOwnProperty(key) && p.indexOf(key) >= 0) return key;
    return 'garden-bouquet';
  }

  /* 15 oz? doc tu o dang chon; khong doc duoc thi coi la 11 oz. */
  function la15() {
    var t = '';
    var ck = document.querySelectorAll('input:checked, option:checked');
    for (var i = 0; i < ck.length; i++) {
      t += ' ' + (ck[i].value || '') + ' ' + (ck[i].textContent || '');
      var lb = ck[i].closest && ck[i].closest('label');
      if (lb) t += ' ' + lb.textContent;
    }
    return /15\s*oz/i.test(t);
  }

  function fonts() {
    if (document.getElementById('gy-mug-fonts')) return;
    var l = document.createElement('link');
    l.id = 'gy-mug-fonts'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Pinyon+Script'
           + '&family=Caveat:wght@600&family=Cormorant+Garamond:wght@400&display=swap';
    document.head.appendChild(l);
  }
  function fontsReady() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all([
      document.fonts.load('80px "Pinyon Script"', 'Grandma'),
      document.fonts.load('600 60px "Caveat"', 'Grandma'),
      document.fonts.load('400 20px "Cormorant Garamond"', 'EMMA')
    ]).catch(function () {});
  }

  function field(k) { return document.querySelector('[name="properties[' + k + ']"]'); }
  function val(k, mac) { var e = field(k); return (e && e.value.trim()) || mac || ''; }
  function names() {
    return val('Grandchildren', '').split(/\r?\n|,/)
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length; })
      .slice(0, TOI_DA_TEN);
  }

  var cache = {};
  function img(src, cb) {
    if (!src) return cb(null);
    if (cache[src]) return cb(cache[src]);
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () { cache[src] = im; cb(im); };
    im.onerror = function () { cb(null); };
    im.src = src;
  }

  /* --- do & ve chu, neo theo TAM VET MUC --- */
  function dat(ctx, px, ff, wght) { ctx.font = (wght ? wght + ' ' : '') + px + 'px ' + ff; }
  function rong(ctx, txt, track, px) {
    if (!track) return ctx.measureText(txt).width;
    var w = 0;
    for (var i = 0; i < txt.length; i++) w += ctx.measureText(txt[i]).width + track * px;
    return w - track * px;
  }
  /* co chu lon nhat <= px ma van nam trong limit */
  function vuaBe(ctx, txt, ff, px, wght, limit) {
    while (px > 8) { dat(ctx, px, ff, wght); if (ctx.measureText(txt).width <= limit) return px; px -= 3; }
    return px;
  }
  function veGiua(ctx, txt, cx, cyPx, px, ff, hex, wght, track) {
    dat(ctx, px, ff, wght);
    ctx.fillStyle = hex; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
    var w = rong(ctx, txt, track, px);
    var m = ctx.measureText(txt);
    var asc = m.actualBoundingBoxAscent || px * 0.7, des = m.actualBoundingBoxDescent || px * 0.2;
    var base = cyPx - (des - asc) / 2, x = cx - w / 2;
    if (track) {
      for (var i = 0; i < txt.length; i++) {
        ctx.fillText(txt[i], x, base); x += ctx.measureText(txt[i]).width + track * px;
      }
    } else ctx.fillText(txt, x, base);
  }
  /* xep ten thanh <= toi_da dong, moi dong <= limit */
  function xuongDong(ctx, ten, sep, track, px, limit, toiDa) {
    var dong = [], cur = [];
    for (var i = 0; i < ten.length; i++) {
      var thu = cur.concat([ten[i]]);
      if (cur.length && rong(ctx, thu.join(sep), track, px) > limit) { dong.push(cur.join(sep)); cur = [ten[i]]; }
      else cur = thu;
    }
    if (cur.length) dong.push(cur.join(sep));
    return { dong: dong, vua: dong.length <= toiDa };
  }

  function veBong(ctx, cx, cy, r, mau, nhuy, canh) {
    for (var i = 0; i < canh; i++) {
      var a = i * 2 * Math.PI / canh;
      ctx.save();
      ctx.translate(cx + Math.cos(a) * r * 0.62, cy + Math.sin(a) * r * 0.62);
      ctx.rotate(a);
      ctx.beginPath(); ctx.ellipse(0, 0, r * 0.52, r * 0.40, 0, 0, 2 * Math.PI);
      ctx.fillStyle = mau; ctx.fill(); ctx.restore();
    }
    ctx.beginPath(); ctx.arc(cx, cy, r * 0.22, 0, 2 * Math.PI);
    ctx.fillStyle = nhuy; ctx.fill();
  }

  var PINYON = '"Pinyon Script", cursive';
  var CAVEAT = '"Caveat", cursive';
  var CORM   = '"Cormorant Garamond", Georgia, serif';

  function veA(ctx, ba, ns) {
    var px = vuaBe(ctx, ba, PINYON, 250, null, AN_TOAN);
    veGiua(ctx, ba, W / 2, 0.650 * H, px, PINYON, '#3A352E', null, 0);
    if (!ns.length) return;
    var up = ns.map(function (t) { return t.toUpperCase(); });
    var p = 62, r;
    while (true) {
      dat(ctx, p, CORM, 400);
      r = xuongDong(ctx, up, '  ', 0.14, p, AN_TOAN, 2);
      if (r.vua || p <= 40) break;
      p -= 4;
    }
    var ys = r.dong.length === 1 ? [0.815] : [0.792, 0.855];
    for (var i = 0; i < r.dong.length && i < 2; i++)
      veGiua(ctx, r.dong[i], W / 2, ys[i] * H, p, CORM, '#8C8274', 400, 0.14);
  }

  function veB(ctx, ba, ns) {
    var n = ns.length, haiHang = n > 4;
    var BC = haiHang ? { td: 0.230, hang: [0.435, 0.660], tag: null }
                     : { td: 0.310, hang: [0.555], tag: 0.780 };
    veGiua(ctx, ba, W / 2, BC.td * H, vuaBe(ctx, ba, CAVEAT, 210, 600, AN_TOAN),
           CAVEAT, '#342E28', 600, 0);
    var hang = haiHang ? [ns.slice(0, Math.ceil(n / 2)), ns.slice(Math.ceil(n / 2))] : [ns];
    var stt = 0;
    for (var h = 0; h < hang.length; h++) {
      var ds = hang[h], m = Math.max(1, ds.length);
      var buoc = Math.min(210, AN_TOAN / m), x0 = W / 2 - buoc * (m - 1) / 2, yh = BC.hang[h] * H;
      for (var j = 0; j < ds.length; j++) {
        var x = x0 + j * buoc;
        veBong(ctx, x, yh, 46, MAU[stt % 6], NHUY[stt % 6], stt % 2 ? 6 : 5);
        ctx.strokeStyle = '#96A58C'; ctx.lineWidth = 4;
        ctx.beginPath(); ctx.moveTo(x, yh + 50); ctx.lineTo(x, yh + 106); ctx.stroke();
        veGiua(ctx, ds[j], x, yh + 148, 62, CAVEAT, '#342E28', 600, 0);
        stt++;
      }
    }
    if (BC.tag !== null) {
      var t = 'Every name I get to love.';
      veGiua(ctx, t, W / 2, BC.tag * H, vuaBe(ctx, t, CAVEAT, 58, 600, AN_TOAN),
             CAVEAT, '#80766A', 600, 0);
    }
  }

  function veB2(ctx, ba, ns) {
    veGiua(ctx, ba, W / 2, 0.420 * H, vuaBe(ctx, ba, CAVEAT, 190, 600, AN_TOAN),
           CAVEAT, '#342E28', 600, 0);
    var n = ns.length;
    if (n) {
      var cot = n <= 4 ? 1 : 2, moiCot = Math.ceil(n / cot);
      var buoc = 0.083 * H, y0 = 0.590 * H;
      var tam = cot === 1 ? [W / 2] : [W / 2 - 0.088 * W, W / 2 + 0.088 * W];
      for (var i = 0; i < n; i++)
        veGiua(ctx, ns[i], tam[Math.floor(i / moiCot)], y0 + (i % moiCot) * buoc,
               76, CAVEAT, '#342E28', 600, 0);
    }
    var t = 'Every name I get to love.';
    veGiua(ctx, t, W / 2, 0.925 * H, vuaBe(ctx, t, CAVEAT, 58, 600, AN_TOAN),
           CAVEAT, '#80766A', 600, 0);
  }

  var VE = { A: veA, B: veB, B2: veB2 };

  function render(cv, bgs) {
    var S = SPEC[kind()], ctx = cv.getContext('2d');
    var to = la15(), CH = to ? H15 : H, dy = to ? DY15 : 0;
    if (cv.height !== CH) cv.height = CH;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, VW, CH);
    ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, VW, CH);
    ctx.translate(-L * W, dy);          // ve theo toa do dai in day du
    img(bgs[S.base], function (im) {
      if (im) ctx.drawImage(im, 0, 0, W, H);
      VE[S.kieu](ctx, val('Grandma name', 'Grandma'), names());
    });
  }

  function boot() {
    var host = document.getElementById('gy-mug');
    if (!host || !field('Grandchildren')) return setTimeout(boot, 400);
    fonts();
    var bgs = window.GY_MUG_BG || {};
    host.innerHTML =
      '<canvas id="gy-mug-cv" width="' + VW + '" height="' + H + '"' +
      ' style="width:100%;height:auto;display:block;border-radius:10px;background:#fff"></canvas>' +
      '<p style="font-size:15px;color:#5f5f5f;margin:8px 0 0;text-align:center">' +
      'This is exactly what we print. Please check every spelling before you order.</p>';
    var cv = document.getElementById('gy-mug-cv'), t = null;
    function go() {
      clearTimeout(t);
      t = setTimeout(function () { fontsReady().then(function () { render(cv, bgs); }); }, 120);
    }
    ['Grandma name', 'Grandchildren'].forEach(function (k) {
      var e = field(k); if (e) e.addEventListener('input', go);
    });
    // doi co coc: variant picker khong bao su kien rieng, nghe change tren ca trang
    document.addEventListener('change', go, true);
    fontsReady().then(go);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go);
    window.addEventListener('load', go);
    go();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
